import React, { useEffect, useState } from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Zoom from '@material-ui/core/Zoom'
import Progress from '@material-ui/core/CircularProgress'
import { tmzOptions, tmzParse } from 'components/atoms/tmzOptions'

import {
  Typography,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'

import { useDispatch, useSelector } from 'react-redux'
import { fetchCamera, fixStreamCamera } from 'features/Cameras/camerasSlice'
import { updateTmz, updateOsd } from 'features/Devices/devicesSlice'

import { Button, useInput } from 'sputnik-ui'
import { useTranslation } from 'react-i18next'

function Transition(props) {
  return <Zoom direction="up" {...props} />
}

function CameraModal({ uuid, open, handleClose, ...props }) {
  const dispatch = useDispatch()
  const camera = useSelector(({ camerasNew }) => camerasNew.current)
  const { t } = useTranslation(['devices'])

  const {
    value: tmzConfig,
    bind: bindTmz,
    setValue: setTmz,
  } = useInput(tmzOptions[0])

  const [tmzChanged, setTmzChanged] = useState(false)

  useEffect(() => {
    if (uuid) dispatch(fetchCamera(uuid))
  }, [dispatch, uuid])

  useEffect(() => {
    if (camera?.tmz !== undefined) {
      setTmz(tmzParse(camera?.tmz))
    }
  }, [camera, setTmz])

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      PaperProps={{ style: styles.dialog }}
    >
      <DialogTitle style={{ position: 'relative' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '1rem',
          }}
        >
          {camera && (
            <Typography variant="h6" style={{ fontWeight: 'bold' }}>
              {camera.serial_number}
            </Typography>
          )}

          {camera && (
            <Typography style={{ display: 'flex', alignItems: 'center' }}>
              {t('devices:cameras.unit')} FW {camera.fwVersion}
            </Typography>
          )}

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '1rem',
              width: '100%',
            }}
          >
            {camera && (
              <FormControl style={{ flexGrow: 1, maxWidth: '200px' }}>
                <InputLabel htmlFor="ext_com">
                  {t('devices:params.choose_tmz')}
                </InputLabel>
                <Select
                  {...bindTmz}
                  onChange={(e) => {
                    setTmz(tmzParse(e.target.value))
                    setTmzChanged(true)
                  }}
                >
                  {tmzOptions.map(({ value, label }) => (
                    <MenuItem value={value} key={value}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {camera && tmzChanged && (
              <Button
                primary
                onClick={() => {
                  dispatch(
                    updateTmz({ deviceUuid: camera.uuid, tmz: tmzConfig })
                  )
                  setTmzChanged(false)
                }}
              >
                {t('devices:params.save_tmz')}
              </Button>
            )}
            {camera && camera.embed && (
              <Button
                secondary
                onClick={() => dispatch(fixStreamCamera(camera.uuid))}
              >
                {t('devices:params.stream_sync')}
              </Button>
            )}
            {camera && (
              <Button
                secondary
                onClick={() => dispatch(updateOsd(camera.uuid))}
              >
                {t('devices:params.update_osd')}
              </Button>
            )}
          </div>
        </div>
      </DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        {camera ? (
          camera.embed ? (
            <div style={styles.responsiveContainer}>
              <iframe
                title="camera-stream"
                src={camera.embed}
                frameBorder="0"
                style={styles.responsiveElement}
                autoPlay={false}
                allow="autoplay; fullscreen"
                allowFullScreen
                sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-pointer-lock"
                referrerPolicy="no-referrer"
              />
            </div>
          ) : (
            <Typography color="error" align="center">
              {t('devices:cameras.not_available')}
            </Typography>
          )
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '100px 0',
            }}
          >
            <Progress />
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}

const styles = {
  icon: {
    marginRight: 8,
    width: '1rem',
    height: '1rem',
  },
  dialog: {
    // overflow: 'visible',
    width: '80%',
    maxWidth: 800,
  },
  responsiveContainer: {
    height: 0,
    paddingTop: '56.25%',
    position: 'relative',
    overflow: 'hidden',
    // borderRadius: 5,
    boxShadow: '0px 0px 30px rgba(0,0,0,0.1)',
  },
  responsiveElement: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgb(250, 251, 250)',
  },
}

export default CameraModal
